<template>
  <div>

    <b-card class="px-1 my-1">

      <b-row>
        <b-col class="d-flex justify-content-end">
          <b-button 
            class="btn btn-success" 
            @click="onRedirectToCreate()"
          >Crear</b-button>
          
          <b-button
            class="ml-1"
            variant="success"
            size="sm"
            @click="descargarCartLab()"
            v-b-tooltip.hover
            title="Descargar Cartera Laboratorio"
          >
            <div v-if="descargandoExcel">
              <b-spinner small type="grow"></b-spinner>
              <label style="color: whitesmoke;">Descargando..</label> 
            </div>
            <i class="fas fa-file-excel"></i>
          </b-button>  
        </b-col>
      </b-row>
      
      <b-row >

        <b-form-input 
          v-model="filters.search" 
          placeholder="Buscar por codigo o descripcion de el examen."
          type="text" 
          class="col-6 col-lg-6 my-1" 
        />


        <v-select
          v-if="isXima"
          id="establecimiento"
          v-model="filters.establecimiento"
          :options="establecimientosOpts"
          :reduce="option => option.value"
          placeholder="Seleccionar establecimiento."
          label="text"
          class="col-3 col-lg-3 pl-0 my-1"
        />

        <v-select 
          id="areaanalisis" 
          v-model="filters.area" 
          :options="areasOpts" 
          placeholder="Buscar por area."
          :reduce="option => option.value" 
          label="text" 
          class="col-3 col-lg-3 pl-0 my-1" 
        />

        <v-select 
          id="estado" 
          v-model="estado" 
          placeholder="Seleccionar estado." 
          :options="estados"
          :reduce="option => option.value" 
          label="text" 
          class="col-3 col-lg-3 pl-0 my-1" 
        />


        <b-button 
          variant="primary" 
          @click="buscarLaboratorio"  
          class="col-2 col-lg-2 pl-0 my-1 ml-1" 
        >
          <font-awesome-icon icon="magnifying-glass" style="color: white;" />
          Buscar
        </b-button>

      </b-row>

      <div v-if="canModificar">
        <hr/>

        <b-row >
          <h5 class="col-12">Modificar informacion de cartera</h5>
          <!-- <v-select 
            v-model="modificar.estado" 
            placeholder="Estado." 
            :options="estados"
            :reduce="option => option.value" 
            label="text" 
            class="col-2" 
          /> -->

          <v-select 
            id="tipoImagen" 
            v-model="modificar.area" 
            :options="areasOpts"
            :reduce="option => option.value" 
            placeholder="Area" 
            label="text" 
            class="col-3 " 
          />

          <b-col md="4" class="col-2">
            <b-button 
              variant="primary" 
              @click="modificarItems"
            >
              <span style="color: white;">
                Cambiar
              </span>
            </b-button>

          </b-col>
        </b-row>
      </div>
    </b-card>

    <b-overlay 
      :show="mostrarLoader" 
      opacity="0.50" 
      rounded="sm"
    >
      <b-card class="principal">

        <b-table 
          v-if="items.length > 0" 
          bordered striped responsive 
          :items="items" 
          :fields="fieldsTable" 
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc" 
          :sort-direction="sortDirection" 
        >
          <template #cell(check)="data">
            <b-form-checkbox @change="selectedLaboratorio(data.item.idLaboratorio)"/>
          </template>

          <template #cell(estadoJson)="data">
            <div class="row">
              <label class="col-6" >Iess: <label :class="data.item.estadoJson.iess? 'text-success' : 'text-danger'"> {{ data.item.estadoJson.iess? 'Activo' : 'Inactivo' }} </label> </label> 
              <label class="col-6">Issfa: <label :class="data.item.estadoJson.issfa? 'text-success' : 'text-danger'"> {{ data.item.estadoJson.issfa? 'Activo' : 'Inactivo' }} </label> </label> 
            
              <label class="col-6" >Isspol: <label :class="data.item.estadoJson.isspol? 'text-success' : 'text-danger'"> {{ data.item.estadoJson.isspol? 'Activo' : 'Inactivo' }} </label> </label> 
              <label class="col-6">Particular: <label :class="data.item.estadoJson.particular? 'text-success' : 'text-danger'"> {{ data.item.estadoJson.particular? 'Activo' : 'Inactivo' }} </label> </label> 
            </div>
          </template>

          <template #cell(estado)="data">
            <label 
              v-if="data.item.estado === '1'"
              style="
                background-color: #92DB92;
                box-shadow: 0 0 10px rgba(4, 219, 0, 0.6);
                border-radius: 3px;
                padding: 3px;
              " 
            >
              Activo
            </label>

            <label 
              v-else
              style="
                background-color: #DBD5CC;
                border-radius: 3px;
                padding: 3px;
              " 
            >
              Inactivo
            </label>
          </template>

          <template #cell(establecimientos)="data">
            <div class="d-flex flex-column text-left">
              <span
                v-for="est in data.item.establecimientos"
                :key="est.id"
              >
                {{ est.nombre }}:
                <span :class="est.activo ? 'text-success' : 'text-danger'">
                  {{ est.activo ? 'Activo' : 'Inactivo' }}
                </span>
              </span>
            </div>
          </template>

          <template #cell(acciones)="data">
            <div class="d-flex justify-content-end">

              <b-button 
                variant="info" 
                size="sm" 
                @click="viewItem(data.item.tokenLaboratorio)"
              >
                <font-awesome-icon icon="magnifying-glass" style="color: white;" />
              </b-button>

              <b-button 
                variant="primary" 
                size="sm" 
                @click="onEditLaboratorio(data.item.tokenLaboratorio)"
              >
                <font-awesome-icon icon="user-pen" style="color: white;" />
              </b-button>

              <b-button 
                variant="danger" 
                size="sm" 
                @click="removeItemid(data.item.idLaboratorio)"
              >
                <font-awesome-icon icon="circle-xmark" style="color: white;" />
              </b-button>
            </div>
          </template>
        </b-table>


        <div v-else class="text-center">
          <p>No se encontraron registros</p>
        </div>

        <b-pagination 
          v-if="items.length > 0" 
          v-model="table.page" 
          :total-rows="table.totalRows"
          :per-page="table.perPage" 
          first-number 
          class="mb-0" 
          align="center"
          prev-class="prev-item" 
          next-class="next-item" 
          @change="cambiarPagina"
        >
          <template #prev-text>
            <feather-icon icon="ChevronLeftIcon" size="18" />
          </template>

          <template #next-text>
            <feather-icon icon="ChevronRightIcon" size="18" />
          </template>
        </b-pagination>
      </b-card>
    </b-overlay>

    <b-modal 
      v-model="modalShow" 
      @show="cargarComponente" 
      title="Detalles del Laboratorio" 
      size="lg"
      hide-footer
    >
      <component 
        :is="componenteDinamico" 
        v-if="componenteDinamico" 
        :token="tokenSeleccionado"/>
    </b-modal>


    <SaveLaboratorioCartera/>

  </div>
</template>

<script>
import { BootstrapVue } from 'bootstrap-vue';
import actions          from '@/assets/utils/utils'
import BCardCode        from '@core/components/b-card-code'
import vSelect          from 'vue-select'
import axios            from 'axios';
import { comprobarPermisos, comprobarRoles, getEstablecimientoLS } from "@/shared/helpers";
import rutas from '@/assets/utils/rutas.json';
import CrearLaboratorio  from '@/views/laboratorio/CrearLaboratorio.vue';
import EditarLaboratorio from '@/views/laboratorio/EditarLaboratorio.vue';
import SaveLaboratorioCartera   from '@/views/laboratorio/components/SaveLaboratorioCartera/SaveLaboratorioCartera.vue';
import { carteraLaboratorioService } from './services';
import { ROLES } from '../../shared/constants';
import { get } from 'jquery';
import { establecimientosService } from '@/views/administracion/services';


export default {
  components: {
    ...BootstrapVue.components,
    BCardCode,
    vSelect,
    CrearLaboratorio,
    EditarLaboratorio,
    SaveLaboratorioCartera
  },

  data() {

    return {

      filters: {
        search: null,
        area: null,
        establecimiento: null,
      },

      table:{
        page     : 1,
        perPage  : 15,
        totalRows: 0
      },

      descargandoExcel : false,
      modificar:{
        estado:null,
        area:null,
        establecimiento:null
      },

      showVisibleModalCreate: false,
      showVisibleModalEdit: false,
      tokenLabEditar: null,

      tokenSeleccionado: null,
      modalShow: false,
      componenteDinamico: null,
      pagina_actual: 1,
      currentPage: 1,
      currentPageModificado: 1,
      mostrarLoader: false,
      login_user: '',

      consultarlaboratorio: null,
      consultarestablecimiento: '',
      consultarareaanalisis: '',
      areasOpts: [],
      establecimientosOpts: [],
      establecimientosMap: {},
      currentEstablecimiento: getEstablecimientoLS && getEstablecimientoLS(),

      establecimiento: '',
      perPage: 15,
      pageOptions: [3, 5, 10],
      totalRows: 3,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },

      fieldsTable: [
        // { key: 'check',           label: '',                 thClass: 'text-center' },
        { key: 'estadoJson',      label: 'Estado',           sortable: true, thClass: 'text-center' },
        // { key: 'estado',          label: 'Estado',           sortable: true, thClass: 'text-center' },
        { key: 'establecimientos',label: 'Establecimiento',  sortable: false, thClass: 'text-center' },
        { key: 'descripcion',     label: 'Descripcion',      sortable: true, thClass: 'text-center' },
        { key: 'areaanalisis',    label: 'Area',             sortable: true, thClass: 'text-center' },
        { key: 'usuario',         label: 'Usuario',          sortable: true, thClass: 'text-center' },
        { key: 'acciones',        label: 'acciones',         sortable: true, thClass: 'text-center', tdClass: 'text-right' },
      ],

      listaAcciones: [],
      token_usuario: '',
      configdateTimePicker: {
        enableTime: false,
        dateFormat: 'd/m/Y',
      },
      items: [],
      descripcion: '',
      idsLaboratorios: [],
      estado: null,
      estados: [
        { value: '1', text: 'Activo' },
        { value: '0', text: 'Inactivo' }
      ],
    }
  },
  async created() {

    comprobarPermisos(this.$route);
    this.setToken();
    this.fetchAreaAnalisis();
    await this.fetchEstablecimientos();
    await this.loadCartera();
    this.abrirModalDesdeQuery();
  },

  mounted() {
    actions.setearTitulo('Laboratorio Clinico');
  },

  methods: {


    async modificarItems(){
      if (!this.idsLaboratorios.length) {
        this.$swal.fire({
          icon: "error",
          text: "Por favor, seleccione al menos un item."
        });

        return;
      }

      if(this.modificar.estado)
        await this.modificarEstados();

      if(this.modificar.area)
        await this.modificarArea();

      if(this.modificar.establecimiento)
        await this.modificarEstablecimiento();

      this.$router.go(0);
    },

    abrirModalDesdeQuery() {
      const viewLab = this.$route.query.viewLab;
      if (viewLab) {
        this.tokenSeleccionado = viewLab;
        this.modalShow = true;
      }
    },


    async modificarEstados() {

      const responseModificar = await carteraLaboratorioService.modificarEstadoMultiples(this.idsLaboratorios, this.modificar.estado);

      if (responseModificar) {
        await this.$swal.fire({
          title: 'Exito',
          icon: 'success',
          text: 'Estado de laboratorios actualizados correctamente!'
        })
      }
    },


    async modificarArea(){

      const responseModificar = await carteraLaboratorioService.modificarAreaMultiples(this.idsLaboratorios, this.modificar.area);

      if (responseModificar) {
        await this.$swal.fire({
          title: 'Exito',
          icon: 'success',
          text: 'Area de laboratorios actualizados correctamente!'
        })
      }
    },


    async modificarEstablecimiento(){

      const responseModificar = await carteraLaboratorioService.ModificarEstabLaboratorios(this.idsLaboratorios, this.modificar.establecimiento);

      if(responseModificar){
        await this.$swal.fire({
          title: 'Exito',
          icon: 'success',
          text: 'Establecimiento de laboratorios actualizados correctamente!'
        });
      }
    },


    selectedLaboratorio(id) {
      const index = this.idsLaboratorios.indexOf(id);

      if (index !== -1) {
        this.idsLaboratorios.splice(index, 1);
      } else {
        this.idsLaboratorios.push(id);
      }

    },

    onRedirectToCreate() {
      // this.showVisibleModalCreate = true;
      this.navigateToQuery('saveLab', '0');
    },

    async descargarCartLab() {

      this.descargandoExcel   = true;
      const establecimiento   = getEstablecimientoLS()?.id;


      const query = `
        query obtenerLaboratorios(
          $search         : String, 
          $establecimiento: String, 
          $areaanalisis   : String, 
          $page           : Int, 
          $pageSize       : Int, 
          $estado         : String,
          $excel          : String
        ) {
          allLabs(
            search         : $search
            establecimiento: $establecimiento
            areaanalisis   : $areaanalisis
            page           : $page
            excel          : $excel
            pageSize       : $pageSize
            estado         : $estado
          ) {
            message
            status
            total
            labfile
          }
        }
      `;

      const variables = {
        estado          : '1',
        search          : this.filters.search,
        establecimiento : establecimiento,
        areaanalisis    : this.filters.area,
        page            : this.table.page,
        pageSize        : this.table.pageSize,
        excel           : '1',
      }

      try{
        const response = await axios.post(rutas.axios + 'api', { query, variables });
        if(response.status !== 200) return;

        const response2 = response.data.data.allLabs;
        if(response2.status !== 'Success') return;

        const archivo = response2.labfile;
        actions.cargarArchivos(archivo, "cartera_laboratorios.xlsx", "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64")
        
      }catch(error){
        console.error('An error occurred while fetching the options:', error);
      }
        
         
      this.descargandoExcel = false;
    },


    onEditLaboratorio(tokenLaboratorio) {

      this.navigateToQuery('saveLab', tokenLaboratorio);
      
    },

    navigateToQuery(queryParam, valueQuery) {
      try {
        this.$router.push({
          path: this.$route.path,
          query: {
            ...this.$route.query,
            [queryParam]: valueQuery,
          },
        });
      } catch (error) {
        console.error("Error en la navegación:", error);
      }
    },


    viewItem(tokenLaboratorio) {
      this.tokenSeleccionado = tokenLaboratorio;
      this.modalShow = true;
    },

    cargarComponente() {
      import('./Verlaboratorio.vue').then(componente => {
        this.componenteDinamico = componente.default;
      }).catch(error => {
        console.error('Error al cargar el componente:', error);
      });
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
    },

    cambiarPagina(newPage) {
      this.table.page = newPage;
      this.loadCartera();
    },


    async fetchAreaAnalisis() {
      const query = `
        query obtenerAreaAnalisis {
          allAreaslab {
            descripcion
            id
          }
        }        
      `;
      try {
        const response = await axios.post(rutas.axios + 'api', { query });
        this.areasOpts = response.data.data.allAreaslab.map(item => ({
          value: item.id,
          text: item.descripcion
        }));
      } catch (error) {
        console.error('An error occurred while fetching the options:', error);
      }
    },

    async fetchEstablecimientos() {
      const list = await establecimientosService.getForSelect();
      this.establecimientosOpts = list || [];
      this.establecimientosMap = (list || []).reduce((acc, est) => {
        if (est && est.value !== null && est.value !== undefined) {
          acc[String(est.value)] = est.text;
        }
        return acc;
      }, {});
    },



    async loadCartera(){

      const establecimiento = getEstablecimientoLS();
      const establecimientoId = this.isXima
        ? (this.filters.establecimiento ? String(this.filters.establecimiento) : null)
        : (establecimiento && establecimiento.id ? String(establecimiento.id) : null);

      const params = {
        establecimiento : establecimientoId,
        search          : this.filters.search || '', 
        area            : this.filters.area   || null, 
        page            : this.table.page,
        pageSize        : this.table.perPage
      }

      let response = await carteraLaboratorioService.getAll(params);

      // Si el backend falla al filtrar por establecimiento, reintenta sin ese filtro.
      if(!response && establecimientoId){
        const paramsSinEst = { ...params, establecimiento: null };
        response = await carteraLaboratorioService.getAll(paramsSinEst);
      }

      if(!response || !response.laboratorios) return;

      this.items = response.laboratorios.map(item => {

        const descripcion = `(${item.codigo}) ${item.descripcion}`;
        const precioJson  = item.precioJson ? JSON.parse(item.precioJson) : {};
        const estadoJson  = item.estadoJson ? JSON.parse(item.estadoJson) : {};
        const estIds = (item.establecimiento || '')
          .split(',')
          .map(e => e.trim())
          .filter(Boolean);
        const establecimientos = Object.entries(this.establecimientosMap).map(([id, nombre]) => ({
          id,
          nombre,
          activo: estIds.includes(id),
        }));

        return {
          idLaboratorio    : item.id,
          tokenLaboratorio : item.token,
          descripcion      : descripcion,
          establecimientos,
          areaanalisis     : item.areaanalisis.descripcion,
          precio           : item.precio,
          usuario          : item.usuarioCreador?.username || '',
          estado           : item.estado,
          estadoJson
        };
      });

      this.table.totalRows = response.total;
    },



    buscarLaboratorio() {
      this.loadCartera()
    },



    removeItemid(idLaboratorio) {
      const mesa = this.fetchRemoveLaboratorio(idLaboratorio);
    },

    async fetchRemoveLaboratorio(idLaboratorio) {

      this.$swal({
        title: 'Estas seguro de eliminar este Laboratorio?',
        text: "No seras capaz de revertir esto!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, Borrar esto!',
        cancelButtonText: 'No, cancelar!'
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const argTerp = {
              laboratorioDatos: {
                id: parseInt(idLaboratorio),
                estado: "0"
              }
            };

            const response = await axios.post(rutas.axios + 'api', {
              query: ` 
                mutation EliminarLaboratorio($laboratorioDatos: LabInputDelete!) {
                  eliminarLaboratorio(laboratorioDatos: $laboratorioDatos) {
                    laboratorioActualizado {
                      id
                      estado
                    }
                    status
                    message
                  }
                }
              `,
              variables: argTerp
            });
            if (response.status === 200) {
              if (response.data.data.eliminarLaboratorio.status === 'success') {
                if (response.status === 200) {
                  this.$swal({
                    title: 'Borrado!',
                    text: 'Tu registro ha sido eliminado',
                    icon: 'success',
                    confirmButtonColor: '#3085d6'
                  }).then((result) => {
                    // This will only run when the user presses "OK" on the "Deleted!" modal
                    if (result.isConfirmed) {
                      this.$router.go(0);
                    }
                  });
                }
                this.$router.push({ name: 'consultar_cartera_examen' }).catch(err => {
                  if (err.name !== 'NavigationDuplicated') {
                    console.error(err);
                  }
                });
              } else {
                this.$swal({
                  title: 'Error',
                  text: response.data.data.eliminarLaboratorio.message,
                  icon: 'error',
                  confirmButtonColor: '#089599',
                })
              }
            }
          } catch (err) {
            console.log(err);
            return 'Error al eliminar el laboratorio';
          }
        } else {
          // User clicked the cancel button
          this.$swal({
            title: 'Cancelado',
            text: 'Your registro esta seguro :)',
            icon: 'error',
            confirmButtonColor: '#3085d6'
          });
        }
      });
    },

    setToken() {
      const user = JSON.parse(localStorage.getItem('usuario'))
      this.login_user = user.username
      axios.defaults.headers.common.Authorization = `JWT ${user.token}`
    },

    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
  },

  computed:{
    canModificar(){
      const hasRole = comprobarRoles([ROLES.JEFE_MEDICO, ROLES.JEFE_VALIDACIONES, ROLES.AUDITOR, ROLES.JEFE_AUDITOR]);
      return hasRole
    },
    isXima() {
      return this.currentEstablecimiento?.uniCodigo === '36451';
    },
  },

  watch: {
    '$route.query.viewLab': {
      deep: true,
      handler() {
        this.abrirModalDesdeQuery();
      }
    }
  }
}
</script>
